export default {
  // Payout account (Stripe Connect)
  payoutTitle: 'Payout account',
  payoutDescription: "Connect a bank account with Stripe to receive your commission automatically as tenants you've referred are billed.",
  commissionShare: 'You earn {percent}% of the $11-per-employee revenue from every company attributed to you.',
  connected: 'Connected',
  setupRequired: 'Setup required',
  opening: 'Opening…',
  updatePayoutDetails: 'Update payout details',
  setUpPayoutAccount: 'Set up payout account',

  // Dashboard
  dashboardTitle: 'Dashboard',
  dashboardDescription: "Companies you've referred and the commission you've earned.",
  statusNone: 'Not started',
  statusTrialing: 'Trial',
  statusActive: 'Active',
  statusPastDue: 'Payment failed',
  statusCanceled: 'Cancelled',
  statusIncomplete: 'Incomplete',
  statusIncompleteExpired: 'Checkout expired',
  statusExpired: 'Trial ended',
  atCapTitle: "You have {count} trial tenants that haven't subscribed yet. Convert one, or ask us to raise the limit.",
  newTrialTenant: 'New trial tenant',
  payoutBanner: 'Set up your payout account to start receiving commission automatically.',
  setUpPayouts: 'Set up payouts',
  statReferred: 'Referred companies',
  statOpenTrials: 'Trials not yet subscribed',
  limitReached: 'Limit reached',
  statCommission: 'Commission earned to date',
  noCompaniesYet: 'No companies yet',
  emptyMessage: 'Create a trial tenant for a prospect and it will show up here, along with any company we attribute to you.',
  colCompany: 'Company',
  colFirstAdmin: 'First admin',
  colCreated: 'Created',
  colSeats: 'Seats',
  colCommission: 'Commission earned',
  welcomeResent: 'Welcome link re-sent to {email}.',
  sending: 'Sending…',
  resendLink: 'Resend link',

  // Directory listing
  listingTitle: 'Directory listing',
  listingDescription: 'Appear in the reseller directory on the CrewPresence website so companies looking for a local partner can find you.',
  listingSavedLive: 'Listing saved. It is live on the website.',
  listingSavedHidden: 'Listing saved. It is hidden from the website.',
  showInDirectory: 'Show {company} in the public directory',
  live: 'Live',
  notListed: 'Not listed',
  privacyNote: 'Only what you enter below is shown, plus your company name. Your login email, name and phone from your application stay private.',
  region: 'Region',
  regionHint: 'Where you operate, e.g. “Perth, WA” or “Australia-wide”.',
  regionPlaceholder: 'Perth, WA',
  about: 'About you',
  aboutHint: '{count}/{max}. What you do for your clients.',
  aboutPlaceholder: 'Managed IT and mobile fleets for WA construction and civil contractors.',
  website: 'Website',
  websitePlaceholder: 'https://example.com.au',
  publicEmail: 'Public email',
  emailPlaceholder: 'sales@example.com.au',
  publicPhone: 'Public phone',
  phonePlaceholder: '08 5550 0000',
  needContact: 'Add a website, email or phone number so customers can reach you.',
  saveListing: 'Save listing',

  // New trial tenant dialog
  createdTitle: 'Trial tenant created',
  welcomeSent: "We've emailed <b>{email}</b> a link to choose their password. It's valid for 7 days, and you can resend it from your dashboard.",
  welcomeFailed: 'The tenant exists but the welcome email to <b>{email}</b> could not be sent. Use “Resend welcome” on your dashboard to try again.',
  ownLinkSent: 'Your own admin link went to <b>{email}</b>.',
  newTenantTitle: 'New trial tenant',
  newTenantDescription: "Sets up the prospect's company and emails their admin a link to choose a password.",
  companyName: 'Company name',
  timeZone: 'Time zone',
  theirFirstAdmin: 'Their first admin',
  adminEmail: 'Admin email',
  nameOptional: 'Name (optional)',
  addMe: 'Also give me an admin login on this tenant',
  myEmailLabel: 'Email for your admin login',
  myEmailHint: "Must differ from your reseller login and from the prospect's email, e.g. you+clientname@yourfirm.com.",
  creating: 'Creating…',
  createTrialTenant: 'Create trial tenant',
}
